// This file is AUTOGENERATED, do not edit it manually!!!

export const commonClient = {
    about_item: 'À propos de {0}',
    activity_plural: '1#{0} activité#{0} activités',
    add: 'Ajouter',
    AddMoreSpace: 'Mettez à niveau maintenant',
    all_projects_label: 'Tous les projets',
    approve_label: 'Approuver',
    approved: 'Approuvé',
    approvers: 'Approbateur',
    archive_action_text: 'Archiver',
    archive_date_label: 'Date d\'archivage',
    archived_by_label: 'Archivé par',
    Attach: 'Joindre un fichier',
    attach_file_image: 'Joindre un fichier ou une image',
    automation_purchase_notes: 'Veuillez contacter <a href=\'mailto:billing@birdviewpsa.com\'>billing@birdviewpsa.com</a> si vous souhaitez utiliser un autre mode de paiement que la carte de débit.',
    automation_trial_description_end: 'et découvrez l\'automatisation Birdview en action !',
    automation_trial_description_middle: 'Essai gratuit de 30 jours',
    automation_trial_description_start: 'Commencez avec notre ',
    automation_trial_expired: 'Votre période d\'essai a expiré.',
    automation_trial_expired_notes: 'Veuillez contacter notre <a href=\'mailto:support@birdviewpsa.com\'>support@birdviewpsa.com</a> pour obtenir de l\'aide.',
    btn_reload: 'Recharger',
    buy_subscription: 'Acheter un abonnement',
    Cancel: 'Annuler',
    change: 'Changer',
    checkbox_list_text: 'Sélection multiple',
    Close: 'Fermer',
    completeActivityConfirm: 'Vous avez indiqué que cette activité est terminée à 100 %. Voulez-vous terminer l\'activité ? Appuyez sur « OK » pour changer le statut ou sur « Annuler » sinon.',
    completeActivityTitle: 'Voulez-vous terminer cette activité ?',
    completeProjectConfirm: 'Vous avez indiqué que ce projet est terminé à 100 %. Voulez-vous terminer ce projet ? Appuyez sur « OK » pour changer le statut.',
    completeProjectTitle: 'Voulez-vous terminer ce projet ?',
    confirmCompleteActivityParents: 'La réalisation de cette activité ne laissera aucune activité non terminée dans ce projet (activité parente). Voulez-vous également terminer le projet ou l\'activité parente, selon le cas ?',
    confirmCompleteActivityParentsTitle: 'Définir le statut de {0} comme terminé ?',
    contact_us: 'Nous contacter',
    continue: 'Continuer',
    copied_label: 'Copié',
    copy_link_feedback: 'Lien copié.',
    copying_label: 'Copie en cours',
    copyLink: 'Copier le lien',
    custom_field_label: 'Champ personnalisé',
    custom_form_label: 'Formulaire personnalisé',
    date_text: 'Date',
    DayAbbreviation: 'j',
    DayPluralFormat: '1#jour#jours',
    DayPluralFormatTemplate: '1#{0} jour#{0} jours',
    Delete: 'Supprimer',
    delete_confirmation: 'Cette action est irréversible.',
    delete_permanently_text: 'Supprimer définitivement',
    description_information: 'pour {0}',
    disabled: 'Désactivé',
    disabledUserText: '(désactivé)',
    Download: 'Télécharger',
    dropdown_text: 'Liste déroulante',
    Duplicate: 'Dupliquer',
    Edit: 'Modifier',
    ElapsedTime_Ago: 'il y a {0}',
    enabled: 'Activé',
    Entity_Category: 'Catégorie',
    Entity_Customer: 'Client',
    Entity_Invoice: 'Facture',
    Entity_Issue: 'Problème',
    Entity_JobRole: 'Rôle',
    Entity_OAuthAccountClient: 'Client OAuth',
    Entity_Portfolio: 'Portefeuille',
    Entity_Priority: 'Priorité',
    Entity_Project: 'Projet',
    Entity_ProjectStatus: 'Statut',
    Entity_Request: 'Demande',
    Entity_Task: 'Tâche',
    Entity_TaskStatus: 'Statut',
    Entity_User: 'Utilisateur',
    Error_CantFindObjectTemplate: 'L’opération n’a pas pu être effectuée pour la/les raison(s) suivante(s) : l’élément (type : {entityName}, ID : {objectKey}) est introuvable dans la base de données. Cela peut être dû à la suppression de l’élément ou à l’absence de droits d’accès. Veuillez consulter votre administrateur {brandName} pour les causes possibles.',
    error_notFullyCompleted: 'Un objet ou un utilisateur concerné a été supprimé ou les autorisations d\'accès ont été révoquées par un autre utilisateur.',
    ErrorFileSizeLimit: 'Le téléchargement du fichier {0} n’a pas pu être effectué, car la taille du fichier ne doit pas dépasser ∼ {1} Go',
    ErrorUploadExceededText: 'Le téléchargement du fichier {0} n’a pas pu être effectué, car votre compte n’a plus d’espace disponible.',
    ErrorUploadText: 'Le téléchargement du fichier {0} a rencontré une erreur inconnue et n’a pas pu être terminé. Veuillez réessayer le téléchargement.',
    ErrorUploadTitle: 'Erreur de téléchargement du fichier.',
    ErrorVirusText: 'Le fichier que vous essayez de joindre peut contenir un virus. Veuillez retirer le fichier et analyser votre ordinateur pour votre sécurité.',
    ErrorVirusTitle: 'Fichier infecté',
    exported: 'Exporté',
    exporting: 'Exportation en cours',
    failed: 'Échec',
    help: 'Aide',
    HourAbbreviation: 'h',
    HourPluralFormat: '1#heure#heures',
    HourPluralFormatTemplate: '1#{0} heure#{0} heures',
    HyperLinkTooltip: 'CTRL+Clic pour suivre le lien',
    items_selected_plural: '1#{0} élément sélectionné#{0} éléments sélectionnés',
    madeBy: 'Propulsé par',
    MinuteAbbreviation: 'm',
    MinutePluralFormat: '1#{0} min#{0} min',
    more_counter_text: 'et {0} de plus',
    next: 'Suivant',
    no_items_selected: 'Aucun élément sélectionné',
    None_Text: 'Aucun',
    Not_set: 'Non défini',
    Ok: 'OK',
    one_after_another_label: 'Approbation séquentielle',
    one_after_another_tooltip: 'Les approbateurs doivent approuver dans un ordre défini, l’un après l’autre',
    open_details_new_tab: 'Ouvrir les détails dans un nouvel onglet',
    open_in_new_tab: 'Ouvrir dans un nouvel onglet',
    OpeningWindow: 'Ouverture...',
    OpenOriginal: 'Ouvrir l’original',
    OperationError_Title: 'L’opération n’a pas pu être effectuée',
    paragraph_text: 'Texte de paragraphe',
    parentActivity: 'activité parente',
    PerDay: 'par jour',
    PerWeek: 'par semaine',
    project_custom_fields_label: 'Champs personnalisés du projet',
    project_plural: '1#{0} projet#{0} projets',
    reject_label: 'Rejeter',
    rejected: 'Rejeté',
    Remove: 'Retirer',
    request_has_been_sent_successfully: 'La demande a été envoyée avec succès. L’équipe de réussite vous contactera.',
    Request_Trial: 'Essayez-le maintenant',
    Reset: 'Réinitialiser',
    Save: 'Enregistrer',
    saved: 'Enregistré',
    saving: 'Enregistrement en cours',
    Search: 'Rechercher',
    select_placeholder: 'Sélectionner...',
    selection_mode_text: 'Mode de sélection',
    sending: 'Envoi en cours',
    setCompleted: 'Marquer comme terminé',
    show_less_label: 'Afficher moins',
    show_more_label: 'Afficher plus',
    space_exceeded_description: 'Il n\'y a pas assez d\'espace de stockage disponible pour enregistrer les fichiers.',
    space_exceeded_title: 'Le stockage est plein',
    status: 'Statut',
    submit: 'Soumettre',
    subscribe_trouble_description: 'Veuillez contacter <a href=\'mailto:success@birdviewpsa.com\'>success@birdviewpsa.com</a> pour clarifier votre statut d\'abonnement.',
    summary: 'Résumé',
    time_input_placeholder: 'Saisissez le temps, ex : 2h 30m',
    timer_text: '1#{0} seconde#{0} secondes',
    title_notFullyCompleted: 'L\'opération n\'a pas pu être réalisée partiellement ou entièrement',
    title_reload: 'Veuillez recharger la page',
    total: 'Total',
    turn_off: 'Désactiver',
    type: 'Type',
    Type_for_search: 'Tapez pour rechercher',
    Type_for_search_or_add: 'Tapez pour rechercher ou ajouter',
    Type_for_search_or_create: 'Tapez pour rechercher ou créer',
    unarchive_action_text: 'Désarchiver',
    undo_label: 'Annuler',
    undoing: 'Annulation en cours',
    undone: 'Annulé',
    upload: 'Téléverser',
    waitingForApproval: 'En attente d\'approbation',
    WebPushNotificationPanelLink: 'activer les notifications sur le bureau.',
    WebPushNotificationPanelText: '{brandName} a besoin de votre autorisation pour ',
    you_user_text: '(vous)',
};
